(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('.announcement__message'));
      const seconds = parseFloat(this.dataset.autorotate);
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.messages.length < 2 || !seconds || reduce) return;

      this.index = 0;
      this.delay = seconds * 1000;
      this.start();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.delay);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
    }

    next() {
      this.messages[this.index].hidden = true;
      this.index = (this.index + 1) % this.messages.length;
      this.messages[this.index].hidden = false;
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('dialog');
      this.sectionId = this.dataset.sectionId;
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    connectedCallback() {
      // Close: explicit buttons + click on the backdrop area.
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) {
          event.preventDefault();
          this.close();
        }
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      // Quantity steppers + remove (delegated, survive content refreshes).
      this.addEventListener('click', (event) => {
        const dec = event.target.closest('[data-qty-decrease]');
        const inc = event.target.closest('[data-qty-increase]');
        const remove = event.target.closest('[data-cart-remove]');
        const line = event.target.closest('[data-line]');
        if (!line) return;

        if (dec || inc) {
          const input = line.querySelector('[data-qty-input]');
          let quantity = parseInt(input.value, 10) || 0;
          quantity = inc ? quantity + 1 : Math.max(0, quantity - 1);
          this.changeLine(line.dataset.line, quantity);
        } else if (remove) {
          event.preventDefault();
          this.changeLine(line.dataset.line, 0);
        }
      });
      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-qty-input]');
        if (!input) return;
        const line = input.closest('[data-line]');
        this.changeLine(line.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
      });

      // Bind page-wide listeners only once.
      if (!CartDrawer.globalsBound) {
        CartDrawer.globalsBound = true;

        document.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-cart-toggle]');
          if (!toggle) return;
          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            event.preventDefault();
            drawer.open();
          }
        });

        document.addEventListener('submit', (event) => {
          const form = event.target;
          if (form.matches && form.matches('form[action*="/cart/add"]')) {
            const drawer = document.querySelector('cart-drawer');
            if (drawer) {
              event.preventDefault();
              drawer.addFromForm(form);
            }
          }
        });
      }
    }

    open() {
      if (this.dialog && !this.dialog.open) this.dialog.showModal();
    }

    close() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    async addFromForm(form) {
      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.setAttribute('aria-busy', 'true');
      try {
        const body = new FormData(form);
        body.append('sections', this.sectionId);
        const response = await fetch(this.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body,
        });
        const data = await response.json();
        if (data && data.sections) {
          this.renderSections(data.sections);
        } else {
          await this.fetchSection();
        }
        this.open();
      } catch (error) {
        console.error('[cart-drawer] add failed', error);
        form.submit();
      } finally {
        if (submitButton) submitButton.removeAttribute('aria-busy');
      }
    }

    async changeLine(line, quantity) {
      this.dialog.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: quantity, sections: this.sectionId }),
        });
        const data = await response.json();
        if (data && data.sections) {
          this.renderSections(data.sections);
        } else {
          await this.fetchSection();
        }
      } catch (error) {
        console.error('[cart-drawer] change failed', error);
      } finally {
        this.dialog.removeAttribute('aria-busy');
      }
    }

    async fetchSection() {
      const response = await fetch(this.root + '?sections=' + this.sectionId);
      const data = await response.json();
      if (data && data[this.sectionId]) this.renderHTML(data[this.sectionId]);
    }

    renderSections(sections) {
      const html = sections[this.sectionId];
      if (html) this.renderHTML(html);
    }

    renderHTML(html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-cart-inner]');
      const current = this.querySelector('[data-cart-inner]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;

      const source = parsed.querySelector('[data-cart-count-source]');
      if (source) this.updateCount(source.getAttribute('data-cart-count-source'));
    }

    updateCount(count) {
      const total = parseInt(count, 10) || 0;
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = total;
        element.hidden = total === 0;
      });
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class ReadMore extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-clamp]');
      this.toggle = this.querySelector('[data-toggle]');
      if (!this.text || !this.toggle) return;

      requestAnimationFrame(() => {
        this.setAttribute('data-collapsed', '');
        if (this.text.scrollHeight - this.text.clientHeight > 4) {
          this.toggle.hidden = false;
        } else {
          this.removeAttribute('data-collapsed');
        }
      });

      this.toggle.addEventListener('click', () => {
        if (this.hasAttribute('data-collapsed')) {
          this.removeAttribute('data-collapsed');
          this.toggle.textContent = this.toggle.dataset.less;
        } else {
          this.setAttribute('data-collapsed', '');
          this.toggle.textContent = this.toggle.dataset.more;
        }
      });
    }
  }
  if (!customElements.get('read-more')) {
    customElements.define('read-more', ReadMore);
  }

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (this.form) this.form.addEventListener('change', () => this.form.submit());
    }
  }
  if (!customElements.get('facet-filters')) {
    customElements.define('facet-filters', FacetFilters);
  }

  document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-sort-value]');
    if (!option) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', option.dataset.sortValue);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  // Close any open facet dropdown when clicking outside of it
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.facet[open]').forEach((facet) => {
      if (!facet.contains(event.target)) facet.removeAttribute('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.lastY = window.scrollY;
      this.ticking = false;
      this.handler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.handler, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handler);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y <= 0) {
          this.removeAttribute('data-scrolled');
          this.removeAttribute('data-hidden');
        } else {
          this.setAttribute('data-scrolled', '');
          if (y > this.lastY && y - this.lastY > 4 && y > 120) {
            this.setAttribute('data-hidden', '');
          } else if (y < this.lastY) {
            this.removeAttribute('data-hidden');
          }
        }
        this.lastY = y;
        this.ticking = false;
      });
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  class MobileNav extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-menu-open]')) {
          event.preventDefault();
          this.open();
        }
      });
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-menu-close]')) {
          event.preventDefault();
          this.close();
        }
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
      const trigger = document.querySelector('[data-menu-open]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (this.dialog.open) this.dialog.close();
      const trigger = document.querySelector('[data-menu-open]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  }
  if (!customElements.get('mobile-nav')) {
    customElements.define('mobile-nav', MobileNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class ShareButton extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', async () => {
        const data = { title: this.dataset.title, url: this.dataset.url };
        if (navigator.share) {
          try { await navigator.share(data); } catch (e) {}
        } else if (navigator.clipboard) {
          try {
            await navigator.clipboard.writeText(this.dataset.url);
            button.setAttribute('data-copied', '');
            setTimeout(() => button.removeAttribute('data-copied'), 1500);
          } catch (e) {}
        }
      });
    }
  }
  if (!customElements.get('share-button')) {
    customElements.define('share-button', ShareButton);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelectorAll('.product__media-slide');
      this.thumbs = this.querySelectorAll('.product__thumb');
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(thumb.dataset.thumb));
      });
    }

    show(mediaId) {
      this.slides.forEach((slide) => {
        slide.hidden = slide.dataset.mediaId !== mediaId;
      });
      this.thumbs.forEach((thumb) => {
        if (thumb.dataset.thumb === mediaId) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }
  }
  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.querySelector('[data-quantity-minus]').addEventListener('click', () => this.step(-1));
      this.querySelector('[data-quantity-plus]').addEventListener('click', () => this.step(1));
    }

    step(delta) {
      const min = parseInt(this.input.min, 10) || 1;
      const current = parseInt(this.input.value, 10) || min;
      this.input.value = Math.max(min, current + delta);
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }

  class VariantSelector extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-variants]');
      this.variants = dataEl ? JSON.parse(dataEl.textContent) : {};
      this.form = this.closest('form');
      this.idInput = this.form ? this.form.querySelector('[data-variant-id]') : null;
      this.addEventListener('change', () => this.onChange());
    }

    selectedOptions() {
      return Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((i) => i.value);
    }

    onChange() {
      const chosen = this.selectedOptions();
      let matchId = null;
      let match = null;
      Object.keys(this.variants).forEach((id) => {
        const v = this.variants[id];
        if (v.options.length === chosen.length && v.options.every((opt, i) => opt === chosen[i])) {
          matchId = id;
          match = v;
        }
      });
      if (!matchId || !match) return;

      if (this.idInput) this.idInput.value = matchId;

      document.querySelectorAll('[data-product-price]').forEach((el) => {
        el.innerHTML = match.price;
      });

      const addButton = this.form ? this.form.querySelector('.product__atc') : null;
      const label = addButton ? addButton.querySelector('[data-add-label]') : null;
      if (addButton) {
        addButton.disabled = !match.available;
        if (label) {
          label.textContent = match.available
            ? addButton.dataset.labelAvailable
            : addButton.dataset.labelSoldout;
        }
      }

      const url = this.dataset.url;
      if (url && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', url + '?variant=' + matchId);
      }
    }
  }
  if (!customElements.get('variant-selector')) {
    customElements.define('variant-selector', VariantSelector);
  }

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const target = document.querySelector(this.dataset.target);
      if (!target || !('IntersectionObserver' in window)) return;
      this.hidden = false;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
              this.removeAttribute('data-visible');
            } else {
              this.setAttribute('data-visible', '');
            }
          });
        },
        { rootMargin: '0px 0px 0px 0px' }
      );
      this.observer.observe(target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  if (!customElements.get('sticky-atc')) {
    customElements.define('sticky-atc', StickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track) return;
      this.prev && this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next && this.next.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.update();
    }
    step() {
      const card = this.track.querySelector('.review-card');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 20;
      return card ? card.offsetWidth + gap : 320;
    }
    scrollByCard(dir) {
      this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.hidden = this.track.scrollLeft <= 2;
      if (this.next) this.next.hidden = this.track.scrollLeft >= max;
    }
  }
  if (!customElements.get('review-carousel')) {
    customElements.define('review-carousel', ReviewCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
